import api from "../../../services/api";
import gridClientBase from "../../../components/gridClientComponentBase";
import cellDeleteCommand from "../../../components/grid/cellDeleteCommand/cellDeleteCommand.vue";
import cellTemplate from "../../../components/grid/cellTemplate/cellTemplate.vue";
import headerTemplate from "../../../components/grid/headerTemplate/headerTemplate.vue";

export default {
	extends: gridClientBase,
	components: {},

	data: function() {
		return {
			loading: false,
			savePendingRequest: null
		};
	},

	created() {
		this.getData();
		var newItem = {
			name: "",
			id: this.indexNewItem
		};
		this.defaultAddRow = newItem;
		this.sort = [{field: "name", dir: "asc"}];
	},

	/* metodi */
	methods: {
		saveData: function() {
			var self = this;
			if (this.savePendingRequest == null) {
				this.savePendingRequest = api.postDrivingLicenseTypesData(this.createdItems, this.updatedItems, this.deletedItems)
				.then(res => {
					self.createdItems = [];
					self.updatedItems = [];
					self.deletedItems = [];

					self.isInEditMode = false;
					self.getData();
				})
				.catch(err => {
					console.log("KO" + err);
				}).finally(_ => {
					self.savePendingRequest = null;
				});
			}
		},
		getData: function() {
			var self = this;
			this.loading = true;

			this.getDrivingLicenseTypes(self);
		},

		getDrivingLicenseTypes: function(self) {
			api.getDrivingLicenseTypesData().then(res => {
				self.loading = false;
				self.items = res.map(function(item) {
					return {
						description: item.description,
						name: item.name,
						id: item.id
					};
				});
			});
		},

		switchEditMode: function() {
			this.isInEditMode = !this.isInEditMode;

			if (!this.isInEditMode) {
				this.clearWorkingData();
				this.getData();
			}

			this.savePendingRequest = null;
		},

		isColumnFilterable(field) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (c && c.filterable) {
					return true;
				}
			}

			return false;
		}
	},

	/* visualizzazione risultati */
	computed: {
		columns: function() {
			return [
				{
					field: "name",
					title: "nome",
					cell: "myCellTemplate",
					width: "100",
					minResizableWidth: '100',
					headerCell: "myHeaderTemplate",
					filterable: true
				},
				{
					field: "description",
					title: "Descrizione",
					cell: "myCellTemplateNotRequired",
					headerCell: "myHeaderTemplate",
					filterable: true
				},
				{
					cell: cellDeleteCommand,
					width: "45",
					minResizableWidth: '45',
					sortable: false,
					headerCell: "myHeaderTemplate"
				}
			];
		}
	}
};
